export const getMainMenu = (item, code = null) => {
  const positionLabel = code
    ? [`PRIMARY___${code}`, `EXPANDED___${code}`, `MOBILE___${code}`]
    : [`PRIMARY`, `EXPANDED`, `MOBILE`];

  return item.locations.find((locationsItem) =>
    positionLabel.includes(locationsItem)
  );
};
